import { UsageTable } from '../UsageTable';
import { EmptyState } from '../atoms/EmptyState';
import { TableSkeleton } from '../atoms/TableSkeleton';
import { EnergyColumnVisibility } from '../EnergyColumnDefinitions';
import { cn } from '@/core/lib/utils';
import { SiteNode } from '../../types/types';

interface MainGridProps {
  data: SiteNode[];
  columnVisibility: EnergyColumnVisibility;
  selectedActorId?: string;
  isTreeViewVisible: boolean;
  isResizing: boolean;
  isLoading?: boolean;
  selectedChargingStatuses?: string[];
  selectedAllocatedRanges?: string[];
  hideInactive?: boolean;
  viewMode?: 'single' | 'operator';
  onSessionClick?: (sessionId: string | null, machineName?: string, machineId?: number) => void;
  unitMode?: 'A' | 'kW';
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
}

export function MainGrid({
  data,
  columnVisibility,
  selectedActorId,
  isTreeViewVisible,
  isResizing,
  isLoading = false,
  selectedChargingStatuses = [],
  selectedAllocatedRanges = [],
  hideInactive = false,
  viewMode = 'single',
  onSessionClick,
  unitMode = 'A',
  onLoadMore,
  hasMore = false,
  isLoadingMore = false,
}: MainGridProps) {
  return (
    <div className={cn(
      "flex-1 min-w-0",
      isResizing ? 'transition-none' : 'transition-all duration-300 ease-in-out',
      isTreeViewVisible ? 'ml-1 md:ml-2 lg:ml-4' : 'ml-0'
    )}>
      {isLoading ? (
        <TableSkeleton columnVisibility={columnVisibility} />
      ) : (
        <div className="bg-white rounded-lg border">
          {data && data.length > 0 ? (
            <UsageTable
              data={data}
              columnVisibility={columnVisibility}
              selectedActorId={selectedActorId}
              selectedChargingStatuses={selectedChargingStatuses}
              selectedAllocatedRanges={selectedAllocatedRanges}
              isTreeViewVisible={isTreeViewVisible}
              hideInactive={hideInactive}
              serverSideFiltered={viewMode === 'operator'}
              onSessionClick={onSessionClick}
              unitMode={unitMode}
              onLoadMore={onLoadMore}
              hasMore={hasMore}
              isLoadingMore={isLoadingMore}
            />
          ) : (
            <EmptyState
              title={viewMode === 'operator' ? 'No machines available' : 'No actor hierarchy available'}
              description={viewMode === 'operator' ? 'No machines found for this operator.' : 'Please select a location to view the actor hierarchy.'}
            />
          )}
        </div>
      )}
    </div>
  );
}
